import { React } from 'react';
import styled from 'styled-components';

import RankingTotalView from '../../Model/Individual/NoteModel/RankingTotalView';

function RankingPage () {
  return (
    <Container>
      <RankingTotalView/>
    </Container>
  )
}

export default RankingPage;

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;